import { FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { memo } from 'react';
import { FilterTagAlternate } from '../../components/filter-tags';
import { AppliedFilters } from '../applied-filters/applied-filters';
import { AppliedFiltersTags } from '../applied-filters/components/applied-filters-tags/applied-filters-tags';
import type { CustomTagFilterProps as Props } from './types';

export const CompanyIdsFilter = memo(({ className, ...filter }: Props) => {
  const { params } = useSearchQueryFilter({ select: [filter.field!] });
  const idsLength = params?.[filter.field!]?.split(FILTER_VALUE_SEPARATOR)[1];

  const item: FilterTagAlternate = {
    name: filter.name,
    icon: filter.icon,
    type: filter.type,
    items: [
      {
        name: filter.name,
        tags: [
          {
            data: [
              {
                label: `Selected: ${String(idsLength)}`,
                value: String(idsLength),
              },
            ],
            name: filter.name,
            color: filter.metadata?.color,
            icon: filter.icon,
            type: filter.type,
            field: filter.field!,
          },
        ],
      },
    ],
  };

  if (!idsLength) return null;

  return (
    <AppliedFilters
      {...filter}
      customAppliedFiltersTags={<AppliedFiltersTags tags={item} {...filter} />}
    />
  );
});

CompanyIdsFilter.displayName = 'CompanyIdsFilter';
